import { Component, Input, ElementRef, ViewChild, HostListener, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { BbTooltipComponent } from '../bb-tooltip/bb-tooltip.component';
import { Observable } from 'rxjs';

@Component({
	selector: 'bb-info',
	templateUrl: './bb-info.component.html',
	styleUrls: ['./bb-info.component.scss']
})

export class BbInfoComponent implements OnInit, OnDestroy {
	@Input() chipText: string;
	@Input() contents: string;
	@Input() link: string;
	@Input() icon: string;
	@Input() changeDetector: ChangeDetectorRef; // optional, gets passed to the tooltip

	@ViewChild('tooltip', { static: true }) tooltip: BbTooltipComponent;

	iconHoverObservable: Observable<MouseEvent>;

	constructor(public element: ElementRef) { }

	@HostListener('click', ['$event'])
	onClick(event: MouseEvent): void {
		if (event && event.target && !(event.target as any).href) {
			event.preventDefault();
		}
		event.stopPropagation();
	}

	ngOnInit() {
	}

	onMouseOver() {
		this.tooltip.show();
	}

	onMouseLeave() {
		setTimeout(() => {
			this.tooltip.hideIfNotHovering();
		}, 200);
	}

	ngOnDestroy(): void {
		this.tooltip.hide();
	}
}
